import { render } from "./HelloWorld.vue?vue&type=template&id=07bb3a1c&scoped=true&ts=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=07bb3a1c&scoped=true&lang=scss"

import exportComponent from "D:\\www\\gits\\g-vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07bb3a1c"]])

export default __exports__